import { FeaturesManagement } from '@models/featuresManagement'

export const featuresInitial = {
  features: [] as FeaturesManagement[]
}
